export default __webpack_public_path__ + "0d8bb5b3ee5f5dac9e446d48480d28a9.woff2";